module.exports = __webpack_public_path__ + "static/n5consulting-right-5777dec856f658f74e601fa51cd1770f.mp4";